import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LandingPage.css";
import BackgroundFooter from "./BackgroundFooter";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate(); // React Router hook for navigation
  return (
    <>
<div className="main-container">
<style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
        body {
          font-family: 'Inter', sans-serif;
        }
      `}</style>

      <Container fluid className="landing-page-container px-3">
        <div className="container">
         
            {/* Left Content */}
            <div className=" content">
              <h1 className="lpage fw-bold">Customer Support Portal</h1>
              <p>
          Please attempt to answer all questions with best of your knowledge to get the accurate results. If you
            encounter any technical issues while completing the assessment, please click on the <strong> 'ServQual Support Hub'</strong> on this page.
          </p>
            </div>

          

            {/* Right Content */}
            <div className="row  ">
              <div
                className=" col-md-3 col-12 card1 mb-3 p-3"
                style={{ backgroundColor: "#EAF3FF" , marginLeft:"-30px" }}
              >
                <div className="Name">
                <h3 >
                  ServQual Unicorn Security Assessment Nexus
                </h3>
                </div>
                <a href="https://unicorn.servqualit.com/" className="btn susan">SUSAN</a>

              </div>
              <div
                className=" col-md-3 col-12 card1 mb-3 p-3"
                style={{ backgroundColor: "#DFF7E5", marginLeft:"30px" }}
              > <div className="Name">
                <h3 className="cardname">ServQual Support Hub</h3>
                </div>
                <Link to="/support" className="btn" id="btn1" > SUPPORT </Link>
              </div>
            </div>
            </div>

            
        
      </Container>
      <BackgroundFooter />
      </div>
    </>
  );
};

export default LandingPage;
